<template>
    <div class="pin-pad">
      <div class="pin-pad-row" v-for="(row, index) in keypad" :key="index">
        <button class="but" v-for="(key, index) in row" :key="index" @click="onKeyPress(key)">
          {{ key }}
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "PinPad",
    data() {
      return {
        keypad: [
          ["1", "2", "3"],
          ["4", "5", "6"],
          ["7", "8", "9"],
          ["", "0", "del"],
        ],
      };
    },
    methods: {
      onKeyPress(key) {
        this.$emit("key-pressed", key);
      },
    },
  };
  </script>
  
  <style>
  .pin-pad {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .pin-pad-row {
    display: flex;
  }
  
  .but {
    margin: 5px;
    padding: 10px;
    border-radius: 5px;
    border: none;
    background-color: #eee;
    font-size: 18px;
    width: 50px;
    height: 50px;
  }
  
  button:hover {
    background-color: #ccc;
  }
  </style>